import React from 'react';
import PropTypes from 'prop-types';

class LoadMoreTrigger extends React.Component {
  handleOnClick() {
    this.props.onClick();
  }

  renderArrow() {
    return (
      <svg
        width="8"
        height="15"
      >
        <g>
          <path
            fill="var(--arrow)"
            stroke="#000"
            opacity="0.5"
            d="m142.5,23"
          />
            <path
              stroke="#000"
              fill="var(--arrow)"
              strokeWidth="0"
              d="m8.154953848979414,8.299279114074945 l-4.067272693236768,7.117727832096338 l-4.0672723395613435,-7.117727832096338 l8.134545032798112,0 z"
            />
        </g>
      </svg>
    );
  }

  render(){
    return(
      <div
        className="load-more-trigger"
        onClick={this.handleOnClick.bind(this)}
      >
        <span className="load-more-trigger__text button is-small is-light">
          Show More
          {this.renderArrow()}
        </span>
      </div>
    );
  }
}

LoadMoreTrigger.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default LoadMoreTrigger;
